﻿document.addEventListener("DOMContentLoaded", () => {
    const faqItems = document.querySelectorAll<HTMLDivElement>(".faq-item");

    faqItems.forEach((item) => {
        const button = item.querySelector<HTMLButtonElement>("button");
        const content = item.querySelector<HTMLDivElement>(".faq-content");
        const icon = item.querySelector<SVGElement>("svg");

        if (!button || !content || !icon) return;

        button.addEventListener("click", () => {
            const isOpen = item.classList.contains("open");

            if (isOpen) {
                item.classList.remove("open");
                content.classList.add("max-h-0", "opacity-0");
                content.classList.remove("max-h-96", "opacity-100");
                icon.classList.remove("rotate-180");
            } else {
                item.classList.add("open");
                content.classList.remove("max-h-0", "opacity-0");
                content.classList.add("max-h-96", "opacity-100");
                icon.classList.add("rotate-180");
            }
        });
    });
});
